export enum FlatStatus {
  Available = 1,
  Sold = 2,
  Reserved = 3,
  Mortgaged = 4,
  NotOpenForSale = 5,
  LandOwner = 6,
  Refuge = 7
}

export type FlatsStatus = {
  [key in FlatStatus]: string;
};

export const FLAT_STATUS_LIST: FlatsStatus = {
  [FlatStatus.Available]: 'Available',
  [FlatStatus.Sold]: 'Sold',
  [FlatStatus.Reserved]: 'Reserved',
  [FlatStatus.Mortgaged]: 'Mortgaged',
  [FlatStatus.NotOpenForSale]: 'Not Open For Sale',
  [FlatStatus.LandOwner]: 'Land Owner',
  [FlatStatus.Refuge]: 'Refuge'
};
